<template>
  <p class="block--archive__counter" role="status" v-html="label" />
</template>

<script>
import { defineComponent, inject } from 'vue';

export default defineComponent( {
  name: 'Counter',
  setup() {
    const { count, label } = inject( 'count' );

    return {
      label,
      count
    };
  }
} );
</script>
